import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, mergeProps as _mergeProps, withKeys as _withKeys, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-cy"]
const _hoisted_3 = { style: {"z-index":"2","position":"relative","border":"none"} }
const _hoisted_4 = ["align"]
const _hoisted_5 = { class: "filter-menu" }
const _hoisted_6 = {
  key: 0,
  style: {"z-index":"1","position":"relative"}
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["onClick", "onContextmenu", "data-cy"]
const _hoisted_9 = ["align"]
const _hoisted_10 = ["align"]
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { style: {"background":"#fff"} }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["align"]
const _hoisted_18 = {
  key: 0,
  class: "scroll-to-btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        style: {"position":"relative","overflow-y":"hidden","border-radius":"15px"},
        onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.displayScrollToBtn())),
        onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideScrollToBtn()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "table-responsive",
            style: _normalizeStyle(`height: fit-content; overflow-y: auto; max-height: ${_ctx.height}; max-width: ${_ctx.width}`),
            id: `infinite-list-${_ctx.random}`
          }, [
            _createElementVNode("table", {
              class: _normalizeClass(_ctx.tableClass),
              "data-cy": _ctx.prefixCy + '_table'
            }, [
              _createElementVNode("thead", {
                class: _normalizeClass(_ctx.getHeadClass())
              }, [
                _renderSlot(_ctx.$slots, "header", { headers: _ctx.headers }, () => [
                  _createElementVNode("tr", _hoisted_3, [
                    (_ctx.showSelect)
                      ? (_openBlock(), _createElementBlock("th", {
                          key: 0,
                          scope: "col",
                          class: _normalizeClass(_ctx.getTheadClasses()),
                          align: "center",
                          justify: "left",
                          style: {"padding":"0px 8px"}
                        }, [
                          _renderSlot(_ctx.$slots, "header.data-table-select", {}, () => [
                            _createVNode(_component_v_checkbox_btn, {
                              color: _ctx.checkBoxColor,
                              density: "comfortable",
                              class: "pa-0 ma-0 mx-2",
                              "hide-details": "",
                              indeterminate: _ctx.isIndeterminate,
                              dense: _ctx.xDense,
                              onClick: _ctx.selectAll,
                              ripple: false,
                              "model-value": _ctx.isAllSelect
                            }, null, 8, ["color", "indeterminate", "dense", "onClick", "model-value"])
                          ])
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, index) => {
                      return (_openBlock(), _createElementBlock("th", {
                        key: index,
                        class: _normalizeClass(_ctx.getTheadClasses(header)),
                        align: header && header.align ? header.align : 'left',
                        style: _normalizeStyle(`width: ${
                                        header && header.width ? header.width : 'auto'
                                    }`)
                      }, [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          style: {"flex-wrap":"nowrap"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { class: "flex-grow-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _renderSlot(_ctx.$slots, `header.${
                                                    header && header.value ? header.value : ''
                                                }`, {
                                  headers: _ctx.headers,
                                  header: header
                                }, () => [
                                  _createTextVNode(_toDisplayString(header ? (_ctx.getHeaderTitle(header) ?? "") : ""), 1)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_col, { class: "flex-grow-0 flex-shrink-1" }, {
                              default: _withCtx(() => [
                                (header.sortable)
                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 0,
                                      icon: _ctx.getSortIcon(header.value),
                                      onClick: ($event: any) => (
                                                    _ctx.sort(header && header.value ? header.value : '')
                                                ),
                                      size: "x-small"
                                    }, null, 8, ["icon", "onClick"]))
                                  : _createCommentVNode("", true),
                                (header.filterable)
                                  ? (_openBlock(), _createBlock(_component_v_menu, {
                                      key: 1,
                                      modelValue: 
                                                    _ctx.filters[
                                                        header && header.value ? header.value : ''
                                                    ]
                                                ,
                                      "onUpdate:modelValue": ($event: any) => ((
                                                    _ctx.filters[
                                                        header && header.value ? header.value : ''
                                                    ]
                                                ) = $event),
                                      "offset-y": "",
                                      "close-on-content-click": false,
                                      location: "start"
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_btn_icon, _mergeProps({
                                          icon: "$fa-filter",
                                          size: "x-small",
                                          ref_for: true
                                        }, props, {
                                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                                        }), null, 16)
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_5, [
                                          (
                                                            header.filterable.options &&
                                                            header.filterable.options.input ===
                                                                'date'
                                                        )
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                (
                                                                header.filterable.options
                                                                    .inputType === 'date-picker'
                                                            )
                                                  ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                                                      key: 0,
                                                      modelValue: 
                                                                    _ctx.filter[
                                                                        header && header.value
                                                                            ? header.value
                                                                            : ''
                                                                    ]
                                                                ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                    _ctx.filter[
                                                                        header && header.value
                                                                            ? header.value
                                                                            : ''
                                                                    ]
                                                                ) = $event),
                                                      "hide-details": "",
                                                      textFieldReadOnly: false,
                                                      type: "month"
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                  : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                      key: 1,
                                                      modelValue: 
                                                                    _ctx.filter[
                                                                        header && header.value
                                                                            ? header.value
                                                                            : ''
                                                                    ]
                                                                ,
                                                      "onUpdate:modelValue": ($event: any) => ((
                                                                    _ctx.filter[
                                                                        header && header.value
                                                                            ? header.value
                                                                            : ''
                                                                    ]
                                                                ) = $event),
                                                      outlined: "",
                                                      dense: "",
                                                      "hide-details": "",
                                                      autofocus: ""
                                                    }, {
                                                      append: _withCtx(() => [
                                                        _createVNode(_component_v_btn_icon, {
                                                          icon: "$fa-times",
                                                          size: "small",
                                                          onClick: ($event: any) => (
                                                                            _ctx.clearFilter(
                                                                                header &&
                                                                                    header.value
                                                                                    ? header.value
                                                                                    : '',
                                                                            )
                                                                        ),
                                                          onKeypress: _withKeys(($event: any) => (
                                                                            _ctx.filter[
                                                                                header &&
                                                                                header.value
                                                                                    ? header.value
                                                                                    : ''
                                                                            ] = false
                                                                        ), ["enter"])
                                                        }, null, 8, ["onClick", "onKeypress"])
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              ], 64))
                                            : (
                                                            header.filterable.type === 'equals'
                                                        )
                                              ? (_openBlock(), _createBlock(_component_v_combobox, {
                                                  key: 1,
                                                  class: "border rounded-xl",
                                                  modelValue: 
                                                                _ctx.filter[
                                                                    header && header.value
                                                                        ? header.value
                                                                        : ''
                                                                ]
                                                            ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                _ctx.filter[
                                                                    header && header.value
                                                                        ? header.value
                                                                        : ''
                                                                ]
                                                            ) = $event),
                                                  items: _ctx.comboBoxItemsList(header),
                                                  "item-title": 
                                                                header.filterable.options.toText
                                                            ,
                                                  multiple: "",
                                                  dense: "",
                                                  outlined: "",
                                                  clearable: "",
                                                  "hide-details": "",
                                                  chips: ""
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"]))
                                              : (_openBlock(), _createBlock(_component_v_text_field_filled, {
                                                  key: 2,
                                                  modelValue: 
                                                                _ctx.filter[
                                                                    header && header.value
                                                                        ? header.value
                                                                        : ''
                                                                ]
                                                            ,
                                                  "onUpdate:modelValue": ($event: any) => ((
                                                                _ctx.filter[
                                                                    header && header.value
                                                                        ? header.value
                                                                        : ''
                                                                ]
                                                            ) = $event),
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "",
                                                  autofocus: ""
                                                }, {
                                                  append: _withCtx(() => [
                                                    _createVNode(_component_v_btn_icon, {
                                                      icon: "$fa-times",
                                                      size: "small",
                                                      onClick: ($event: any) => (
                                                                        _ctx.clearFilter(
                                                                            header && header.value
                                                                                ? header.value
                                                                                : '',
                                                                        )
                                                                    ),
                                                      onKeypress: _withKeys(($event: any) => (
                                                                        _ctx.filter[
                                                                            header && header.value
                                                                                ? header.value
                                                                                : ''
                                                                        ] = false
                                                                    ), ["enter"])
                                                    }, null, 8, ["onClick", "onKeypress"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                  : _createCommentVNode("", true),
                                (header.editable)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 2,
                                      color: "primary",
                                      size: "x-small",
                                      icon: "$oss-edit"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ], 14, _hoisted_4))
                    }), 128))
                  ])
                ]),
                _renderSlot(_ctx.$slots, "header.append", {
                  headers: _ctx.headers,
                  style: _normalizeStyle(`height: fit-content; top: ${
                                _ctx.computedRowHeight + 2
                            }px; padding: 0px !important`),
                  class: _normalizeClass(_ctx.getTheadClasses())
                }),
                (_ctx.loading || _ctx.scrollToInProgress)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                      _createElementVNode("th", {
                        colspan: "100",
                        align: "center",
                        style: _normalizeStyle(`height: fit-content; top: ${_ctx.computedRowHeight}px; padding: 0px !important`),
                        class: _normalizeClass(_ctx.getTheadClasses())
                      }, [
                        _createVNode(_component_v_progress_linear, {
                          indeterminate: "",
                          class: "mx-0",
                          color: _ctx.checkBoxColor
                        }, null, 8, ["color"])
                      ], 6)
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (_ctx.filtredItems && _ctx.filtredItems.length)
                ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtredItems, (item, index) => {
                      return _renderSlot(_ctx.$slots, "item", {
                        item: item,
                        index: index,
                        isSelected: _ctx.isSelected(item),
                        onSelect: () => _ctx.addRemoveItem(item, index)
                      }, () => [
                        _withDirectives((_openBlock(), _createElementBlock("tr", {
                          key: index,
                          class: _normalizeClass(_ctx.getTrClasses(item)),
                          style: _normalizeStyle(_ctx.getRowStyle(index)),
                          onClick: _withModifiers(($event: any) => (_ctx.onClick(item)), ["stop"]),
                          onContextmenu: ($event: any) => (_ctx.show($event, item)),
                          "data-cy": _ctx.prefixCy + '_table_' + index
                        }, [
                          (_ctx.showSelect)
                            ? (_openBlock(), _createElementBlock("td", {
                                key: 0,
                                class: _normalizeClass(_ctx.getCellClasses()),
                                align: 
                                            _ctx.headers && _ctx.headers[index] && _ctx.headers[index].align
                                                ? _ctx.headers[index].align
                                                : 'center'
                                        
                              }, [
                                _renderSlot(_ctx.$slots, "item.checkbox", {
                                  item: item,
                                  isSelected: _ctx.isSelected(item),
                                  onSelect: () => _ctx.addRemoveItem(item, index)
                                }, () => [
                                  (_ctx.cbDisplayCondition(item))
                                    ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                        key: 0,
                                        "hide-details": "",
                                        class: "pa-0 my-0 mx-2",
                                        color: _ctx.checkBoxColor,
                                        ripple: false,
                                        dense: _ctx.xDense,
                                        onClick: _withModifiers(($event: any) => (_ctx.addRemoveItem(item, index)), ["stop"]),
                                        "model-value": _ctx.isSelected(item)
                                      }, null, 8, ["color", "dense", "onClick", "model-value"]))
                                    : _createCommentVNode("", true)
                                ])
                              ], 10, _hoisted_9))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, hIndex) => {
                            return (_openBlock(), _createElementBlock("td", {
                              class: _normalizeClass(_ctx.getCellClasses(header)),
                              key: hIndex,
                              align: header && header.align ? header.align : 'left'
                            }, [
                              _renderSlot(_ctx.$slots, 
                                                'item.' +
                                                (header && header.value ? header.value : '')
                                            , {
                                item: item,
                                index: index,
                                header: header,
                                hIndex: hIndex
                              }, () => [
                                (header.editable)
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": ($event: any) => ((
                                                        item[
                                                            header && header.value
                                                                ? header.value
                                                                : ''
                                                        ]
                                                    ) = $event),
                                      type: "text",
                                      class: "input-table"
                                    }, null, 8, _hoisted_11)), [
                                      [_vModelText, 
                                                        item[
                                                            header && header.value
                                                                ? header.value
                                                                : ''
                                                        ]
                                                    ]
                                    ])
                                  : (header.select)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (_ctx.cbDisplayCondition(item))
                                          ? (_openBlock(), _createBlock(_component_v_checkbox, {
                                              key: 0,
                                              "hide-details": "",
                                              class: "pa-0 my-0 mx-2",
                                              color: _ctx.checkBoxColor,
                                              ripple: false,
                                              dense: _ctx.xDense,
                                              onClick: _withModifiers(($event: any) => (_ctx.addRemoveItem(item, index)), ["stop"]),
                                              "model-value": _ctx.isSelected(item)
                                            }, null, 8, ["color", "dense", "onClick", "model-value"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(item[header && header.value ? header.value : ""]), 1))
                              ])
                            ], 10, _hoisted_10))
                          }), 128))
                        ], 46, _hoisted_8)), [
                          [_directive_ripple]
                        ])
                      ])
                    }), 256))
                  ]))
                : (_openBlock(), _createElementBlock("tbody", _hoisted_13, [
                    _createElementVNode("tr", _hoisted_14, [
                      _createElementVNode("td", {
                        colspan: _ctx.headers.length + (_ctx.showSelect ? 1 : 0)
                      }, [
                        _renderSlot(_ctx.$slots, "no-data", {}, () => [
                          _cache[6] || (_cache[6] = _createTextVNode("Aucune donnée disponible"))
                        ])
                      ], 8, _hoisted_15)
                    ])
                  ])),
              _createElementVNode("tfoot", {
                class: _normalizeClass({
                            'fixed-footer': _ctx.fixedFooter,
                        })
              }, [
                _renderSlot(_ctx.$slots, "body.append"),
                (_ctx.haveSum)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                      (_ctx.showSelect)
                        ? (_openBlock(), _createElementBlock("td", {
                            key: 0,
                            class: _normalizeClass(_ctx.getTheadClasses())
                          }, null, 2))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (header, hIndex) => {
                        return (_openBlock(), _createElementBlock("td", {
                          class: _normalizeClass(_ctx.getTheadClasses(header)),
                          key: hIndex,
                          align: header && header.align ? header.align : 'left'
                        }, [
                          (header.sum)
                            ? _renderSlot(_ctx.$slots, 'sum.' + (header && header.value ? header.value : ''), {
                                key: 0,
                                sum: _ctx.getSum(header && header.value ? header.value : ''),
                                header: header,
                                hIndex: hIndex
                              }, () => [
                                _createTextVNode(_toDisplayString(_ctx.getSum(header && header.value ? header.value : "")), 1)
                              ])
                            : _createCommentVNode("", true)
                        ], 10, _hoisted_17))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 2)
            ], 10, _hoisted_2)
          ], 12, _hoisted_1),
          (_ctx.scrollToBtnConfig && _ctx.items.length > _ctx.rowToShow && _ctx.isScrollToBtnVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_ctx.scrollToBtnConfig.up)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 0,
                      location: "top"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          rounded: "",
                          size: "x-small",
                          color: "white",
                          class: "scroll-to-top-btn",
                          disabled: _ctx.scrollToInProgress,
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.scrollTo('top')))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("$fa-arrow-left")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1040, ["disabled"])
                      ]),
                      default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "Remonter à la première ligne", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.scrollToBtnConfig.down)
                  ? (_openBlock(), _createBlock(_component_v_tooltip, {
                      key: 1,
                      location: "bottom"
                    }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_btn, _mergeProps(props, {
                          rounded: "",
                          size: "x-small",
                          color: "white",
                          class: "scroll-to-bottom-btn",
                          disabled: _ctx.scrollToInProgress,
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollTo('bottom')))
                        }), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createTextVNode("$fa-arrow-left")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1040, ["disabled"])
                      ]),
                      default: _withCtx(() => [
                        _cache[10] || (_cache[10] = _createElementVNode("span", null, "Descendre à la dernière ligne", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }),
      (_ctx.displayRowNumber)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "12",
            class: "d-flex justify-end text--secondary"
          }, {
            default: _withCtx(() => [
              (_ctx.itemKeysSelected.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.itemKeysSelected.length) + " /", 1)
                  ], 64))
                : _createCommentVNode("", true),
              _createTextVNode(_toDisplayString(_ctx.itemLength || _ctx.items.length) + " éléments ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.selectedMenuItem)
        ? (_openBlock(), _createBlock(_component_v_menu, {
            key: 1,
            modelValue: _ctx.showMenu,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showMenu) = $event)),
            target: [_ctx.x, _ctx.y],
            absolute: "",
            "offset-y": "",
            "min-width": "250px"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "menu", {
                index: _ctx.getIndex(_ctx.selectedMenuItem),
                item: _ctx.selectedMenuItem,
                close: _ctx.closeMenu
              })
            ]),
            _: 3
          }, 8, ["modelValue", "target"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}